export const SCROLL_TO_WIDGET_EVENT = 'output:internal:widgets:scroll-to-widget';
